'use strict';

/**
 * Returns the pageName value following the naming convention: [market]:[page-slug]
 *
 * @param {string} market The market identifier.
 * @returns {string|null} The formatted pageName or empty string if invalid.
 */
function getPageName(market) {
    if (!market) {
        return '';
    }

    // Extract the page-slug from the current URL (last portion after the last /)
    var pathname = window.location.pathname;
    var pageSlug = pathname.substring(pathname.lastIndexOf('/') + 1);

    // If pageSlug is empty, use the pathname itself
    if (!pageSlug || pageSlug === '') {
        pageSlug = pathname;
    }

    // Remove file extensions (e.g., .html, .htm, .php)
    pageSlug = pageSlug.replace(/\.\w+$/, '');

    var pageName = `${market}:${pageSlug}`.toLowerCase();
    return pageName;
}

/**
 * Retrieves the previously stored page data from sessionStorage.
 *
 * @returns {Object} The previous page data or an empty object if not available.
 */
function getPreviousPageData() {
    try {
        var storedData = sessionStorage.getItem('piwik_previous_page_data');
        return storedData ? JSON.parse(storedData) : null;
    } catch (e) {
        console.error('Piwik Analytics: Error retrieving previous page data:', e);
        return null;
    }
}

/**
 * Saves the current page data to sessionStorage for use in the next page load.
 *
 * @param {Object} currentPageData The current page data to store.
 */
function storePreviousPageData(currentPageData) {
    try {
        var dataToStore = {
            url: currentPageData.url,
            path: currentPageData.path,
            pageTitle: currentPageData.pageTitle,
            pageName: currentPageData.pageName,
            mainCategory: currentPageData.mainCategory,
            categoryTree: currentPageData.categoryTree
        };
        sessionStorage.setItem('piwik_previous_page_data', JSON.stringify(dataToStore));
    } catch (e) {
        console.error('Piwik Analytics: Error storing page data:', e);
    }
}

/**
 * Measure default page view by using a 'defaultPageView' event and the information related with the current page.
 *
 * @param {Object} defaultPageViewData An object containing default page view information.
 * @param {array} dataLayer
 */
function piwikTriggerDefaultPageViewEvent(defaultPageViewData, dataLayer) {
    try {
        var currentPageData = {
            siteName: defaultPageViewData.siteName,
            sysEnv: defaultPageViewData.sysEnv,
            market: defaultPageViewData.market,
            language: defaultPageViewData.language,
            url: window.location.href,
            domain: window.location.hostname,
            path: window.location.pathname,
            pageTitle: document.title,
            pageName: getPageName(defaultPageViewData.market),
            pageType: defaultPageViewData.pageType,
            protected: defaultPageViewData.protected,
            referrer: document.referrer,
            mainCategory: defaultPageViewData.mainCategory,
            categoryTree: defaultPageViewData.categoryTree
        };

        // Retrieve previous page data
        var previousPageData = getPreviousPageData() || {
            url: '',
            path: '',
            pageTitle: '',
            pageName: '',
            mainCategory: '',
            categoryTree: ''
        };

        var data = {
            event: 'defaultPageView',
            eventDetails: 'Page Load',
            timestamp: Math.floor(Date.now() / 1000),
            page: { ...currentPageData, previousPage: previousPageData }
        };

        dataLayer.push(data);

        // Store current page data for the next page load
        storePreviousPageData(currentPageData);
    } catch (e) {
        console.error('Piwik Analytics: Error in piwikTriggerDefaultPageViewEvent:', e);
    }
}

$(function () {
    piwikTriggerDefaultPageViewEvent(window.piwikDefaultPageViewData || {}, window.dataLayer || []);
});
